/** Maintenance screen toggle.
 *
 *  Flip `MAINTENANCE` to `true` while you're taking the backend down for
 *  infra work, then back to `false` once it's live again. Commit + push —
 *  Cloudflare Pages rebuilds in ~1-2 min and the full-screen "resting" takeover
 *  (components/Maintenance.tsx) appears/clears.
 *
 *  It's a build-time constant (not backend-driven) on purpose: the backend
 *  is exactly what's offline during maintenance, so the flag has to live on
 *  the statically-hosted frontend to be reachable. */
export const MAINTENANCE = false;

/** The one editable line on the maintenance screen. Keep it calm. */
export const MAINTENANCE_MESSAGE =
  "";
